import {
    getDataTable, getDataTableForRegularPrices, setPreloader,
} from "../../../Redux/content-reducer";
import {connect} from "react-redux";
import StoreWrapper from "./StoreWrapper";

let mapStateToProps = (state) => {
    return {
        data: state
    }
};

let mapDispatchToProps = {getDataTable, setPreloader, getDataTableForRegularPrices};

export default connect(mapStateToProps, mapDispatchToProps)(StoreWrapper);
